import type { SseRuntimeStore } from '#context/sse/types/sse-runtime-store.type';

import { createSseRuntimeStore } from '#context/sse/store/create-sse-runtime-store';

let runtime: SseRuntimeStore | null = null;

/**
 * Retrieves a singleton instance of the SSE runtime store.
 * If the store has not been created yet, it initializes it with the provided parameters.
 * Subsequent calls will return the same instance, regardless of the parameters.
 *
 * @param uri - The URI endpoint for the SSE connection.
 * @param headers - A record of headers to include in the SSE request.
 * @param onGlobalMessage - Optional callback to handle global message events.
 * @returns The singleton instance of {@link SseRuntimeStore}.
 */
export function getSseRuntimeStore(
  uri: string,
  headers: Record<string, string | undefined>,
  onGlobalMessage?: (e: MessageEvent<string>) => void
): SseRuntimeStore {
  runtime ??= createSseRuntimeStore(uri, headers, onGlobalMessage);

  return runtime;
}
